export default {
	root: {
		borderRadius: 3,
		overflow: "hidden"
	}
};
